// @flow
import React, { Component } from 'react'
import { Button, Card, message, Spin } from 'antd';
import { StyledMember, StyledContent } from './style'
import {withRouter} from "react-router-dom";
import ReactMarkdown from 'react-markdown'
import {getQueryString} from '../../utils/common'
import ApiService from '../../actions/apiService';

class FreeTrial extends Component {
  
  state: State = {
    packageName: "Free Trial",
    price: "0.00",
    isLoading: true,
    content: ''
  }
  
  async componentWillMount() {
    const coupenCode = getQueryString('couponcode');
    this.getContent();
    if (coupenCode) {
      const response = await ApiService.getMethod(`/purchases/checkcoupon?couponCode=${coupenCode}`);
      if (response && response.validCoupon) {
        const {packageName, price} = this.state
        this.props.history.push({
          pathname: '/checkout',
          state: {
            packageId: 4,
            packageName: packageName,
            price: parseFloat(price),
            planLength: '',
            planType: 'recurring',
            promoCode: coupenCode,
          }
        })
      } else {
        message.error('Coupon code is not valid!');
      }
    }
  }
  
  getContent = async () => {
    const response = await ApiService.getMethod(`/description/product/freetrial`);
    if (response) {
      this.setState({
        content: response,
        isLoading: false
      })
    } else {
      this.setState({
        isLoading: false
      })
    }
  }
  
  handleCart = () => {
    const {packageName, price} = this.state
    this.props.history.push({
      pathname: '/checkout',
      state: {
        packageId: 4,
        packageName: packageName,
        price: parseFloat(price),
        planLength: '',
        planType: 'recurring'
      }
    })
  }
  
  render() {
    const {isLoading, content} = this.state;
    return (
      <StyledContent>
        <StyledMember>
          <Card title="Free Trial" bordered={false}>
            {
              isLoading && <Spin />
            }
            {
              !isLoading &&
              <div>
                <p className="price-title">$ 0.00</p>
                <ReactMarkdown escapeHtml={false} source={content || ''}/>
                <Button type="primary" size="large" onClick={this.handleCart}>Checkout</Button>
              </div>
            }
          </Card>
        </StyledMember>
      </StyledContent>
    )
  }
}

export default withRouter(FreeTrial)



// WEBPACK FOOTER //
// ./src/components/shop-pages/FreeTrial.js